import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      setStatus: "ALL",
    };
  }

  componentDidMount = () => {
    // let url = '/api/traces/v1/report/assignall'
    let branchGroup = this.state.user.branch.map((item, index) => {
      return item.org_id;
    });
    // let param = {
    //     org_id: this.state.user.org_id,
    //     user_id: this.state.user.user_id,
    //     source: 'arman',
    //     branch: branchGroup
    // }
    // this.setState({ loading: true })
    // requester.postTraces(url, param, {
    //     success: function(response) {
    //         let { data } = response.data
    //         data.map((item, index) => {
    //             item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
    //             item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
    //             return item
    //         })
    //         this.setState({ loading: false, dataTable: data, baseTable: data})
    //     }.bind(this),
    //     error: function(e) {
    //         this.setState({ loading: false })
    //     }.bind(this)
    // })
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "TRACES NO",
          accessor: "skp_number",
          filterable: true,
        },
        {
          Header: "PROGRAM NO",
          accessor: "program_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_name",
          filterable: true,
        },
        // {
        //     Header: 'START DATE',
        //     accessor: 'start_date',
        // 	Cell: row => (
        // 		<span>
        // 			<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
        // 			</span>
        // 		</span>
        // 	)
        // },
        // {
        //     Header: 'END DATE',
        //     accessor: 'end_date',
        // 	Cell: row => (
        // 		<span>
        // 			<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
        // 			</span>
        // 		</span>
        // 	)
        // },
        {
          Header: "CLAIM EXP DATE",
          accessor: "claim_exp_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },

        {
          Header: "ASSIGNED DATE",
          accessor: "assigned_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          Cell: (row) => (
            <span>
              {row.value.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          ),
          filterable: true,
        },
        {
          Header: "CUSTOMER",
          accessor: "customer_name",
          Cell: (row) => (
            // <div style={{ width:'100%'}}>
            <span>{row.value}</span>
            // </div>
          ),
          filterable: true,
        },
        {
          Header: "STATUS",
          accessor: "status",
          Cell: (row) => (
            <span>{(row.value = "A" ? "ACTIVE" : "INACTIVE")}</span>
          ),
          filterable: true,
        },
        // ,
        // {
        //     Header: 'STATUS',
        //     accessor: 'status'
        // }
      ],

      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            case "START_DATE_PROGRAM":
              columnes = row._original.formatted_START_DATE_PROGRAM;
              break;
            default:
              columnes = row[filter.id];
          }

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "assign-summary-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success">
            <i className="fas fa-file-excel" />
            Export to Excel
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="skp_number" value="skp_number" />
          <ExcelColumn label="program_number" value="program_number" />
          <ExcelColumn label="ref_number" value="ref_number" />
          <ExcelColumn label="program_name" value="program_name" />
          <ExcelColumn label="description" value="description" />
          <ExcelColumn label="principal" value="org_name" />
          {/* <ExcelColumn label="start_date" value="start_date" />
              <ExcelColumn label="end_date" value="end_date" /> */}
          <ExcelColumn label="claim_exp_date" value="claim_exp_date" />
          <ExcelColumn label="assigned_date" value="assigned_date" />
          <ExcelColumn label="budget" value="budget" />
          <ExcelColumn label="customer_name" value="customer_name" />
          <ExcelColumn label="status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/assign/summary/" + row.program_customer_id);
  };

  handleSearch = (e) => {
    let value = e.target.value.toLowerCase();
    let container = [];
    _.find(this.state.baseTable, function (o) {
      let desc = o.description.toLowerCase();
      if (desc.indexOf(value) >= 0) {
        container.push(o);
      }
    });
    container.map((item, index) => {
      item.formatted_start_date = moment(item.start_date).format("DD-MM-YYYY");
      item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
      return item;
    });
    this.setState({ dataTable: container, search: value });
  };

  handleChangeStatus = (e) => {
    this.state.setStatus = e.target.value;
    // let url = '/api/v1/assign/assignsummary?status=' + value
    // let param = {
    //     org_id: this.state.user.org_id
    // }
    // this.setState({ loading: true, search: "" })
    // requester.post(url, param, {
    //     success: function(response) {
    //         let { data } = response.data
    //         data.map((item, index) => {
    //             item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
    //             item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
    //             return item
    //         })
    //         this.setState({ loading: false, dataTable: data, baseTable: data })
    //     }.bind(this),
    //     error: function(e) {
    //         this.setState({ loading: false })
    //     }.bind(this)
    // })
  };

  handleFind = () => {
    // let value = e.target.value
    let url = "/api/traces/v1/report/list-assignment";
    let branchGroup = this.state.user.branch.map((item, index) => {
      return item.org_id;
    });
    let param = {
      org_id: this.state.user.org_id,
      status: this.state.setStatus,
      user_id: this.state.user.user_id,
      source: "arman",
      branch: branchGroup,
      from_date: moment(this.state.fromDate).format("YYYY-MM-DD"),
      to_date: moment(this.state.toDate).format("YYYY-MM-DD"),
    };

    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else if (status === "S") {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    } else if (status === "S") {
      mappingStatus = "ASSIGN";
    }
    console.log(mappingStatus);
    return mappingStatus;
  };

  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 float-left">
                        <div className="row">
                          <div className="col-lg-0">
                            <text>Assign Date From</text>
                          </div>
                          <div className="col-lg-2">
                            {/* <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">From</label> */}

                            <DatePicker
                              // placeholder="Date from"
                              selected={this.state.fromDate}
                              dateFormat="d-MMM-yyyy"
                              className="form-control"
                              popperPlacement="top-end"
                              onChange={this.handlefromDate}
                            />
                          </div>

                          <div className="col-lg-0">
                            <text>Assign Date To</text>
                          </div>
                          <div className="col-lg-2">
                            {/* <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">To</label> */}
                            <DatePicker
                              placeholder="Assigned Date To"
                              selected={this.state.toDate}
                              dateFormat="d-MMM-yyyy"
                              className="form-control"
                              popperPlacement="top-end"
                              onChange={this.handletoDate}
                            />
                          </div>

                          <div className="col-lg-4 float-right">
                            <button
                              type="button"
                              onClick={this.handleFind.bind(this)}
                              className="btn btn-success col-lg-4"
                            >
                              FIND
                            </button>
                          </div>

                          <div className="col-lg-4 float-right">
                            <div className="clearfix">&nbsp;</div>
                            {/* {this.exportToExcel()} */}
                          </div>
                        </div>
                      </div>

                      {/* <div className="row">
                                            <div className="clearfix">&nbsp;</div>
                                                
                                                   
                                                </div> */}
                    </div>
                    {/* <div className="clearfix">&nbsp;</div> */}
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="col-md-6 float-right">
                          {/* <div className="row">
                                                            <div className="col-lg-6">
                                                                <input type="text" className="form-control" onChange={this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                            </div>
                                                            <div className="col-lg-3">
                                                                { this.exportToExcel() }
                                                            </div>
                                                        </div> */}
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
